import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Grid,
  IconButton,
  Card,
  CardContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PriceCard from "../../../components/price_card";
import PricingBill from "../pricing";
import { useNavigate } from "react-router-dom";
import {
  setEncryptedCookie,
  getDecryptedCookie,
  removeCookie,
} from "../../../utils";
import { useSelector } from "react-redux";
import moment from "moment";
const PriceDetails = ({
  open,
  onClose,
  onSubmit,
  trialMessage,
  selectedPlanDetails,
  setShowTrialDetails,
  setModalOpen,
  productDetails,
  setProductDetails,
  setSelectedPlanDetails,
  renewPlan,
  planData,
  busUUID,
  setBusUUID,
  setPlanData,
  setRenewPlan,
  setRenewPlanOff,
  renewPlanOff,
  subUUID,
  setSubUUID,
  planId,
}) => {
  const navigate = useNavigate();
  const organizationItems = useSelector(
    (state) => state.organizationReducer.items
  );
  const [businessModalOpen, setBusinessModalOpen] = useState(false);
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(null);
  const [offerText, setOfferText] = useState();
  const [offerFrom, setOfferFrom] = useState();
  const [offerTo, setOfferTo] = useState();
  const [offer, setOffer] = useState();
  const [pricing, setPricing] = useState();

  const cardColors = ["#FFEBEE", "#E8F5E9", "#E3F2FD", "#F3E5F5", "#FFF3E0"];
  const borderColors = ["#FF4081", "#4CAF50", "#1976D2", "#9C27B0", "#FF9800"];

  const handleCardClick = (index, pricing) => {
    setSelectedPlanIndex(index);
    setPricing(pricing);
    onClose();
    setBusinessModalOpen(true);
  };

  const onBackToPriceDetails = () => {
    setBusinessModalOpen(false);
    setShowTrialDetails(false);
    setModalOpen(true);
  };
  const handleCloseBusinessModal = () => {
    setBusinessModalOpen(false);
    setRenewPlanOff();
    setSelectedPlanIndex();
  };

  const handleClose = () => {
    setRenewPlan();
    setPricing();
    setSelectedPlanIndex();
    setRenewPlanOff();
  };

  const isPlanAvailable =
    renewPlan?.productPlansPricing && renewPlan.productPlansPricing.length > 0;

  const uuid = getDecryptedCookie("puuid");

  const handleOtherPlan = () => {
    navigate("/products/plan");
    setEncryptedCookie("proid", uuid, {
      expires: 7,
    });
    setEncryptedCookie("action", "renew", {
      expires: 7,
    });
  };

  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    if (!isPlanAvailable) {
      const timer = setTimeout(() => {
        setShowMessage(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isPlanAvailable]);

  const frequencyOrder = ["monthly", "quarterly", "halfyearly", "yearly"];

  const sortedFrequencies = renewPlan?.productPlansPricing?.sort(
    (a, b) =>
      frequencyOrder.indexOf(a.frequency) - frequencyOrder.indexOf(b.frequency)
  );

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        BackdropProps={{
          onClick: (e) => e.stopPropagation(),
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 1,
            boxShadow: 24,
            outline: "none",
            position: "relative",
            width: { xs: "90%", sm: "70%" },
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon onClick={handleClose} />
          </IconButton>

          <Typography variant="h6" component="h2">
            Price Details
          </Typography>

          <Typography variant="body1" sx={{ mt: 2 }}>
            {trialMessage}
          </Typography>

          {renewPlanOff?.offer_valid_from && (
            <Grid item xs={12}>
              <Card
                sx={{
                  borderRadius: "15px",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                  background:
                    "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                  color: "#ffffff",
                  padding: "0px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  fontSize: "14px",
                  fontWeight: "bold",
                  height: "auto",
                  overflow: "hidden",
                  transition:
                    "transform 0.3s ease-in-out, box-shadow 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
                  },
                }}
              >
                <CardContent
                  sx={{ padding: "0", width: "100%", marginBottom: "0" }}
                >
                  <Typography
                    sx={{
                      display: "block",
                      margin: "0",
                      marginBottom: "0px",
                      color: "#ffffff",
                      marginTop: "10px",
                      textAlign: "center",
                      fontSize: "30px",
                      fontWeight: "bold",
                      letterSpacing: "1.5px",
                      fontFamily: "'Great Vibes', cursive",
                      fontStyle: "normal",
                      textShadow: "1px 1px 3px rgba(0, 0, 0, 0.3)",
                    }}
                    variant="h5"
                  >
                    {renewPlanOff?.offer_text
                      ? renewPlanOff?.offer_text.charAt(0).toUpperCase() +
                        renewPlanOff?.offer_text.slice(1)
                      : "Limited Time Offer"}
                  </Typography>

                  <Typography
                    sx={{
                      display: "block",
                      margin: "0",
                      color: "#ffffff",
                      marginTop: "8px",
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "600",
                      letterSpacing: "0.5px",
                      textTransform: "uppercase",
                    }}
                  >
                    <span sx={{ fontWeight: "100" }}>Duration:</span>{" "}
                    {renewPlanOff?.offer_valid_from &&
                    renewPlanOff?.offer_valid_to
                      ? `${moment
                          .utc(renewPlanOff?.offer_valid_from)
                          .startOf("day")
                          .format("DD/MM/YYYY")} to ${moment
                          .utc(renewPlanOff?.offer_valid_to)
                          .endOf("day")
                          .format("DD/MM/YYYY")}
                        `
                      : "Dates Not Available"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          )}
          {isPlanAvailable ? (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                {Array?.isArray(sortedFrequencies) &&
                  sortedFrequencies?.map((pricing, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      key={pricing.prd_plan_pricing_uuid}
                    >
                      <PriceCard
                        name={
                          pricing?.frequency
                            ? pricing?.frequency.charAt(0)?.toUpperCase() +
                              pricing?.frequency?.slice(1)
                            : ""
                        }
                        price={pricing?.frequency_price}
                        offerPrice={pricing?.offer_price}
                        description={pricing?.offer_text}
                        color={cardColors[index % cardColors.length]}
                        borderColor={borderColors[index % borderColors.length]}
                        selected={selectedPlanIndex === index}
                        onSelect={() => handleCardClick(index, pricing)}
                        pricing={pricing}
                      />
                    </Grid>
                  ))}
              </Grid>
            </Box>
          ) : (
            showMessage && (
              <Box sx={{ mt: 2, textAlign: "center" }}>
                <Typography variant="h6">
                  Plan is not available right now. You can go with the other
                  plans.
                </Typography>
                <Button
                  onClick={handleOtherPlan}
                  sx={{
                    ml: 2,
                    background:
                      "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                    color: "#fff",
                    padding: "8px 20px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    textTransform: "none",
                    borderRadius: "5px",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.05)",
                      background:
                        "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                    },
                  }}
                >
                  Continue
                </Button>
              </Box>
            )
          )}

          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            {selectedPlanIndex !== null && (
              <Button
                onClick={handleCardClick}
                sx={{
                  ml: 2,
                  background:
                    "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                  color: "#fff",
                  padding: "8px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "5px",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                    background:
                      "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                  },
                }}
              >
                Continue
              </Button>
            )}
          </Box>
        </Box>
      </Modal>

      <PricingBill
        open={businessModalOpen}
        onClose={handleCloseBusinessModal}
        onSubmit={onSubmit}
        trialMessage={trialMessage}
        plans={[]}
        onBackToPriceDetails={onBackToPriceDetails}
        productDetails={productDetails}
        setProductDetails={setProductDetails}
        selectedPlanDetails={selectedPlanDetails}
        setSelectedPlanDetails={setSelectedPlanDetails}
        setShowTrialDetails={setShowTrialDetails}
        pricing={pricing}
        setPricing={setPricing}
        setModalOpen={setModalOpen}
        planData={planData}
        setPlanData={setPlanData}
        busUUID={busUUID}
        setBusUUID={setBusUUID}
        businessModalOpen={businessModalOpen}
        setBusinessModalOpen={setBusinessModalOpen}
        setRenewPlan={setRenewPlan}
        setSelectedPlanIndex={setSelectedPlanIndex}
        renewPlan={renewPlan}
        subUUID={subUUID}
        setSubUUID={setSubUUID}
        planId={planId}
      />
    </>
  );
};

export default PriceDetails;
